'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logDoneRejectionsToConsole = logDoneRejectionsToConsole;
exports.logDoneRejectionsAndSendAlerts = logDoneRejectionsAndSendAlerts;
exports.logDoneRejectionsAndSendNonApiAlerts = logDoneRejectionsAndSendNonApiAlerts;
exports.cancelDoneRejectionHandler = cancelDoneRejectionHandler;

var _other = require('./util/other');

var DONE_REJECTION_PREFIX = '[Q Done]';

function logToConsole(reason) {
  if ((0, _other.isInvalidRejection)(reason)) {
    console.error(DONE_REJECTION_PREFIX, (0, _other.removeNoStackPrefix)(reason), _other.INVALID_REJECTION_SUFFIX);
  } else {
    console.error(DONE_REJECTION_PREFIX, reason);
  }
}
var sendQDoneErrorNotifications = (0, _other.sendCleanedErrorNotificationsWithPrefix)(DONE_REJECTION_PREFIX, { type: 'q-done' });

function onQError() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (typeof Raven === 'undefined' && typeof newrelic === 'undefined') {
    console.error("Q onerror handlers require Raven or New Relic to be already loaded/setup");
  } else if (typeof Q === 'undefined') {
    console.error("Q onerror handlers require Q be already included and available globally");
  } else {
    Q.onerror = function (err) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = funcs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var func = _step.value;

          func(err);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    };
  }
}

function logDoneRejectionsToConsole() {
  onQError(logToConsole);
}

function logDoneRejectionsAndSendAlerts() {
  onQError(logToConsole, sendQDoneErrorNotifications);
}

function logDoneRejectionsAndSendNonApiAlerts() {
  onQError(logToConsole, (0, _other.ifNonApiReason)(sendQDoneErrorNotifications));
}

function cancelDoneRejectionHandler() {
  delete Q.onerror;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-4.11/js/handleDoneErrors.js
// module id = 410
// module chunks = 0